import { ClipboardCheck, Search, FileOutput } from "lucide-react";
const features = [{
  icon: ClipboardCheck,
  title: "Onboarding KYC guiado",
  desc: "Registra a tus clientes con un flujo de 6 pasos que te lleva de la mano. Captura datos personales, sube documentos de identidad, verifica domicilio y genera el expediente completo que exige la ley. Sin errores, sin omisiones."
}, {
  icon: Search,
  title: "Screening PEP/OFAC automático",
  desc: "Verifica a cada cliente contra las listas de Personas Políticamente Expuestas, la lista OFAC (SDN), listas ONU, UE, y la lista SAT Art. 69-B. Resultados en segundos, documentados y con evidencia descargable."
}, {
  icon: FileOutput,
  title: "Reportes listos para la autoridad",
  desc: "Genera la ficha KYC en PDF con el formato que exigen las Reglas de Carácter General. Expediente completo con anexos, listo para auditoría. En el plan Pro: reportes XML para SAT/UIF."
}];
export default function LaSolucion() {
  return <section data-section-id="REEMPLAZAR" id="la-solucion" className="bg-card text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl">
            Todo tu cumplimiento PLD{" "}
            <span className="text-primary font-mono">en un solo lugar</span>
          </h2>
          <p className="mt-4 max-w-[800px] text-lg text-slate-400 font-default">
            Notalia automatiza cada paso del proceso de identificación y conocimiento del cliente — desde la captura de datos hasta el reporte a las autoridades. La plataforma se adapta a tu giro: umbrales, tipos de operación y reportes ajustados a tu fracción del Art. 17.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.title} data-index={i} className="p-6 md:p-8 rounded-lg bg-background border border-border hover:border-primary/40 transition-colors">
                <div className="size-12 rounded-md bg-primary/10 flex items-center justify-center mb-5">
                  <Icon className="size-6 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="font-default text-sm text-slate-400 leading-relaxed">{feature.desc}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}